module.exports = __webpack_public_path__ + "static/media/UPL_F1.a5c3f66a.txt";